import { Component } from '@angular/core';

@Component({
  selector: 'app-no-access',
  standalone: false,
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.less'
})
export class NoAccessComponent {

}
